import { SearchResult } from "@/shared/apis/searchApi";

export const getNextEntry = (array: SearchResult[], entry: SearchResult): SearchResult => {
    if (array.length > 0) {
        let nextEntry = array[0];
        if (entry !== null && entry !== undefined && array.indexOf(entry) !== -1) {
            const index = array.indexOf(entry);
            if (index < array.length - 1) {
                nextEntry = array[index + 1];
            }
        }
        return nextEntry;
    }
};

export const getPreviousEntry = (array: SearchResult[], entry: SearchResult): SearchResult => {
    if (array.length > 0) {
        let previousEntry = array[array.length - 1];
        if (entry !== null && entry !== undefined && array.indexOf(entry) !== -1) {
            const index = array.indexOf(entry);
            if (index > 0) {
                previousEntry = array[index - 1];
            }
        }
        return previousEntry;
    }
};
